import { END_POINTS } from "../helpers";
import emptySplitApi from "../utils/rtk";

type CommonResponse = {
  statusCode: number;
  message?: string;
  data?: any;
};

export const productApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getProducts: builder.query<CommonResponse, {}>({
      query: () => ({
        url: `${END_POINTS.product}`,
        method: "GET",
      }),
    }),

    getProductById: builder.query<
      CommonResponse,
      { productId: string | undefined }
    >({
      query: ({ productId }) => ({
        url: `${END_POINTS.product}/${productId}`,
        method: "GET",
      }),
    }),

    getProductVariants: builder.query<CommonResponse, {}>({
      query: () => ({
        url: `${END_POINTS.productVariants}`,
        method: "GET",
      }),
    }),

    addProduct: builder.mutation<CommonResponse, any>({
      query: (body) => ({
        url: `${END_POINTS.product}/add`,
        method: "POST",
        body,
      }),
    }),
    getAttributes: builder.query<CommonResponse, { categoryId: string }>({
      query: ({ categoryId }) => ({
        url: `${END_POINTS.attribute}/${categoryId}`,
        method: "GET",
      }),
    }),

    updateVariant: builder.mutation<
      CommonResponse & { data: any },
      { body: any; id: string | undefined }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.editVariant}/${id}`,
        method: "PUT",
        body,
      }),
    }),

    updateProduct: builder.mutation<
      CommonResponse & { data: any },
      { body: any; id: string | undefined }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.product}/${id}`,
        method: "PUT",
        body,
      }),
    }),

    deleteProduct: builder.query<CommonResponse, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.product}/${id}`,
        method: "DELETE",
      }),
    }),

    updateProductStatus: builder.mutation<
      CommonResponse & { data: any },
      { id: string | undefined }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.changeProductStatus}/${id}`,
        method: "PUT",
      }),
    }),
  }),
});

export const {
  useAddProductMutation,
  useLazyGetAttributesQuery,
  useLazyGetProductsQuery,
  useLazyGetProductByIdQuery,
  useLazyGetProductVariantsQuery,
  useUpdateVariantMutation,
  useUpdateProductMutation,
  useLazyDeleteProductQuery,
  useUpdateProductStatusMutation,
} = productApi;
